module.exports = __webpack_public_path__ + "static/media/ios-cog.1886c06e.svg";